<span class="p-float-label">
  <textarea pInputTextarea
            rows="5"
            [id]="field"
            [title]="formControl && formControl['value']?formControl['value']:''"
            [placeholder]="' '"
            [value]="formatValue(this.formControl['value'])"
            [disabled]="formControl['disabled']"
            [autoResize]="true"
            (input)="onInput($event)"></textarea>
  <label [for]="field" [innerHTML]="label"></label>
  <app-form-input-error [show]="formControl.invalid && (formControl.dirty || formControl.touched)"
                        [required]="formControl.errors?.['required']"></app-form-input-error>
</span>
